module.exports = __webpack_public_path__ + "static/media/10.d2fcf7fc.png";